export default __webpack_public_path__ + "static/media/galerie4.872fb3fd.jpg";